export const LandingSkeleton = () => {
  return (
    <div className="animate-pulse space-y-10">
      {/* Hero Skeleton */}
      <div className="w-full h-[70vh] bg-gray-200 rounded-none"></div>

      {/* New Additions Skeleton */}
      <div className="px-6 sm:px-48 py-20">
        <div className="h-10 w-60 bg-gray-200 mb-6"></div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="space-y-4">
              <div className="w-full h-64 bg-gray-200"></div>
              <div className="h-5 w-32 bg-gray-300 mx-auto"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Best Sellers Skeleton */}
      <div className="px-6 sm:px-12 lg:px-48 py-20">
        <div className="h-10 w-60 bg-gray-200 mb-10"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div className="h-[400px] sm:h-[500px] bg-gray-300"></div>

          <div className="grid grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="h-44 sm:h-56 bg-gray-200"></div>
            ))}
          </div>
        </div>
      </div>

      {/* Why Choose Us Skeleton */}
      <div className="px-6 sm:px-12 lg:px-48 py-20">
        <div className="h-10 w-48 bg-gray-200 mb-6"></div>

        <div className="space-y-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-5 bg-gray-300 w-3/4"></div>
          ))}
        </div>
      </div>

      {/* Book appointment skeleton */}
      <div className="h-[300px] bg-gray-300"></div>
    </div>
  );
};
